import { useEffect, useState } from 'react'
import { apiGet } from '../Api_Functions'

/**
 * Same data behaviour as the original PartProgressStepper: when `partId` is
 * given the hook polls `part/actualPartProgress/<partId>` every second; when the
 * caller already has the route (Home redesign pushes it down from the unified
 * snapshot tick) it just mirrors `partProgress`.
 *
 * @param {String|Number} partId Part id ('' to disable polling)
 * @param {Array} partProgress Route pushed via props (used when no partId)
 * @returns {Array} steps
 */
export const usePartProgress = (partId, partProgress) => {
  const [steps, setSteps] = useState(partProgress || [])

  useEffect(() => {
    if (!partId) {
      setSteps(partProgress || [])
      return
    }
    let isCurrent = true
    const fetchData = async () => {
      const data = await apiGet('part/actualPartProgress/' + partId)
      if (isCurrent) {
        setSteps(Array.isArray(data) ? data : [])
      }
    }
    fetchData()
    const interval = setInterval(fetchData, 1000)
    return () => {
      isCurrent = false
      clearInterval(interval)
    }
  }, [partId, partProgress])

  return steps
}
